/**
 * Our own /api routes from inside the iPhone app (2026-11-04 sweep). The app bundles its pages and serves them from
 * bamcoaches://localhost, so a relative fetch("/api/...") went to the files on the phone, not to Vercel: @mention
 * notifications, uploads, drill search and the rest silently failed in the app. On native only, fetch is wrapped once
 * so a same-origin /api/ address goes to the platform instead. The server allows the app's origin (api/_auth.js).
 * The web never changes.
 */
export const API_HOST = "https://platform.byanymeanscoaches.com";

/** The address an /api/ request should go to from the app; anything else is left alone. */
export function toApiUrl(url, origin = "") {
  const s = typeof url === "string" ? url : url instanceof URL ? url.href : null;
  if (s == null) return url;
  if (s.startsWith("/api/")) return API_HOST + s;
  if (origin && s.startsWith(`${origin}/api/`)) return API_HOST + s.slice(origin.length);
  return url;
}

export function installNativeApiBase(win = typeof window !== "undefined" ? window : null) {
  if (!win?.Capacitor?.isNativePlatform?.() || typeof win.fetch !== "function") return false;
  if (win.fetch.__bamApiBase) return true;
  const original = win.fetch.bind(win);
  const origin = win.location?.origin || "";
  const wrapped = (input, init) => {
    if (typeof Request !== "undefined" && input instanceof Request) {
      const to = toApiUrl(input.url, origin);
      return original(to === input.url ? input : new Request(to, input), init);
    }
    return original(toApiUrl(input, origin), init);
  };
  wrapped.__bamApiBase = true;
  win.fetch = wrapped;
  return true;
}
